module.exports = __webpack_public_path__ + "img/_5.f0ea0e9c.png";